<template>
   <AllPushRequests />
</template>

<script>

// @ is an alias to /src
import AllPushRequests from "@/components/AllPushRequests.vue";

export default {
name: "SendPushs",
components: {
   AllPushRequests,
},
};
</script>
